import component from "./OnlineJudging";

export default component;
